export const DNI_NIE_CIF_CAPTURE_RESOLUTION_HEIGHT = 1080;
export const DNI_NIE_CIF_CAPTURE_RESOLUTION_WIDTH = 1920;
export const DNI_SIZE_RATIO = 1.77;

export const PASSPORT_CAPTURE_RESOLUTION_HEIGHT = 519;
export const PASSPORT_CAPTURE_RESOLUTION_WIDTH = 378;
export const PASSPORT_SIZE_RATIO = 0.72;
